import tree from '_assets/img/colored-tree.png';
import './style.scss';

const Tree = ({ onClick }: { onClick?: () => void }): React.JSX.Element => {
    return (
        <img
            className="kan-tree"
            src={tree}
            alt="Knit&Note Tree"
            onClick={onClick}
        />
    );
};

export default Tree;
